var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18.0 18.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pen_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pen_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.06,3.1925 L14.81,6.9425 L3.75,18.0025 L0,18.0025 L0,14.2525 L11.06,3.1925 Z M13.96,0.2925 C14.35,-0.0975 14.98,-0.0975 15.37,0.2925 L17.71,2.6325 C18.1,3.0225 18.1,3.6525 17.71,4.0425 L15.88,5.8725 L12.13,2.1225 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-231.0 -1097.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pen_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.9999999999986 1094.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.0 2.9975000000000005)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pen_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 18.0025,0 18.0025,18.0025 0,18.0025 0,0",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.d9447d6b4b01e0f7ab3f5b9af3e13e25.svg";
export { ForwardRef as ReactComponent };